import "../../pages/new/new.scss"

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import { getExaminers } from '../../services/instructorService';
import TextBox from './TextBox';
export const ViewStudentFeedback = () => {;
    const studentId=parseInt(localStorage.getItem('studentId'),10);
    const { feedbackId } = useParams();
    const [feedback, setFeedback] = useState({
        thesisId: '',
        title: '',
        studentId: '',
        studentName: '',
        enrollmentNumber: '',
        mentorName: '',
        examinerName: '',
        overallFeedback: '',
        type: '',
        introMotivation: '',
        problemStmt: '',
        literatureSurvey: '',
        methodology: '',
        results: '',
        conclusionFuturework: '',
        presentation: '',
        reportType:'',
        gradeProposedProblem: '',
        gradeProposedSolution: '',
        gradeProblemUnderstanding: '',
        gradeAcademicRigour: '',
        gradeWorkQuantum: '',
        gradeOverall: ''
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();    
    
    const fetchFeedback = async (id) => {
        try {
            const response = await getFeedbackById(id);
           // console.log(response.data)
            setFeedback(response.data);
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };

    useEffect(() => {
            fetchFeedback(feedbackId);
    }, [feedbackId]);

    const goBack = (e) => {        
            navigate(`/student/feedbacks`)        
    };
    const handleClick = () => {
       // console.log("inside handle click")
        window.open(feedback.reportLink, '_blank');
      };
    return (
        <div>
            <div className="top">
                <h1>{'View Feedback' }</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form >
   
                    <div className="formInput">
                            <label>Report Link</label>
                            <input type="text"
                                name="reportLink"
                                value={feedback.reportLink}
                                readOnly
                                onClick={handleClick}
                                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                                 />
                             </div>

                        <div className="formInput">
                            <label>Feedback Type</label>
                            <input type="text"
                                name="type"
                                value={feedback.type}
                                disabled={true}
                                 />
                             </div>

                             <div className="formInput">
                            <label>Report Type</label>
                            <input type="text"
                                name="reportType"
                                value={feedback.reportType}
                                disabled={true}
                                 />
                             </div>


                        
                        {feedback.type == "Monthly" && <div className="Monthly">
                            <div className="formInput">
                            <label>Month</label>
                            <input type="text"
                                name="month"
                                value={feedback.month}
                                readOnly={true}
                                className={errors.month ? 'error' : ''} />
                            {errors.month && <div className="error-text">{errors.month}</div>}
                        </div>

                        <div className="formInput">
                            <label>Year</label>
                            <input type="text"
                                name="year"
                                value={feedback.year}
                                readOnly={true}
                                className={errors.year ? 'error' : ''} />
                            {errors.year && <div className="error-text">{errors.year}</div>}
                        </div>
                            <div className="monthlyInput">
                                <label>Comments on Introduction & Motivation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="introMotivation"
                                    value={feedback.introMotivation}
                                    readOnly={true}
                                    className={errors.introMotivation ? 'error' : ''} />
                                {errors.introMotivation && <div className="error-text">{errors.introMotivation}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Comments on Problem Statement</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="problemStmt"
                                    value={feedback.problemStmt}
                                    readOnly={true}
                                    className={errors.problemStmt ? 'error' : ''} />
                                {errors.problemStmt && <div className="error-text">{errors.problemStmt}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Comments on Literature Survey</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="literatureSurvey"
                                    value={feedback.literatureSurvey}
                                    readOnly={true}
                                    className={errors.literatureSurvey ? 'error' : ''} />
                                {errors.literatureSurvey && <div className="error-text">{errors.literatureSurvey}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Comments on Methodology</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="methodology"
                                    value={feedback.methodology}
                                    readOnly={true}
                                    className={errors.methodology ? 'error' : ''} />
                                {errors.methodology && <div className="error-text">{errors.methodology}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Comments on Results</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="results"
                                    value={feedback.results}
                                    readOnly={true}
                                    className={errors.results ? 'error' : ''} />
                                {errors.results && <div className="error-text">{errors.results}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Comments on Conclusion & Future Work</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="conclusionFuturework"
                                    value={feedback.conclusionFuturework}
                                    readOnly={true}
                                    className={errors.conclusionFuturework ? 'error' : ''} />
                                {errors.conclusionFuturework && <div className="error-text">{errors.conclusionFuturework}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Comments on Presentation</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="presentation"
                                    value={feedback.presentation}
                                    readOnly={true}
                                    className={errors.presentation ? 'error' : ''} />
                                {errors.presentation && <div className="error-text">{errors.presentation}</div>}
                            </div>



                            <div className="monthlyInput">
                                <label>Overall Feedback</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={true}
                                    className={errors.feedback ? 'error' : ''} />
                                {errors.feedback && <div className="error-text">{errors.feedback}</div>}
                            </div>


                        </div>

                        }


                        {(feedback.type == "Phase1" || feedback.type == "Phase2" || feedback.type == "Phase3") && <div className="Monthly">

                            <div className="examinerGrade">
                                <label>Proposed Problem Grade </label>
                                <select 
                                    name="gradeProposedProblem"
                                    disabled={true}
                                    value={feedback.gradeProposedProblem}
                                    className={errors.gradeProposedProblem ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedProblem && <div className="error-text">{errors.gradeProposedProblem}</div>}
                            </div>



                            <div className="examinerGrade">
                                <label>Proposed Solution Grade </label>
                                <select
                                    name="gradeProposedSolution"
                                    disabled={true}
                                    value={feedback.gradeProposedSolution}
                                    className={errors.gradeProposedSolution ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProposedSolution && <div className="error-text">{errors.gradeProposedSolution}</div>}
                            </div>



                            <div className="examinerGrade">
                                <label>Problem Understanding Grade </label>
                                <select 
                                    name="gradeProblemUnderstanding"
                                    disabled={true}
                                    value={feedback.gradeProblemUnderstanding}
                                    className={errors.gradeProblemUnderstanding ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeProblemUnderstanding && <div className="error-text">{errors.gradeProblemUnderstanding}</div>}
                            </div>


                            <div className="examinerGrade">
                                <label>Academic Rigour Grade </label>
                                <select 
                                    name="gradeAcademicRigour"
                                    disabled={true}
                                    value={feedback.gradeAcademicRigour}
                                    className={errors.gradeAcademicRigour ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeAcademicRigour && <div className="error-text">{errors.gradeAcademicRigour}</div>}
                            </div>



                            <div className="examinerGrade">
                                <label>Work Quantum Grade </label>
                                <select 
                                    name="gradeWorkQuantum"
                                    disabled={true}
                                    value={feedback.gradeWorkQuantum}
                                    className={errors.gradeWorkQuantum ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeWorkQuantum && <div className="error-text">{errors.gradeWorkQuantum}</div>}
                            </div>


                            <div className="examinerGrade">
                                <label>Overall Grade </label>
                                <select 
                                    name="gradeOverall"
                                    disabled={true}
                                    value={feedback.gradeOverall}
                                    className={errors.gradeOverall ? 'error' : ''}>
                                    <option value="">Select a grade</option>
                                    <option value="A">A (Very Good)</option>
                                    <option value="B">B (Good)</option>
                                    <option value="C">C (Satisfactory)</option>
                                    <option value="D">D (Needs Improvement)</option>
                                </select>
                                {errors.gradeOverall && <div className="error-text">{errors.gradeOverall}</div>}
                            </div>


                            <div className="monthlyInput">
                                <label>Overall Feedback</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={true}
                                
                                    className={errors.feedback ? 'error' : ''} />
                                {errors.feedback && <div className="error-text">{errors.feedback}</div>}
                            </div>


                        </div>

                        }
                        {(feedback.type == "ProjectProposal" ) && <div className="Monthly">
                           <div className="monthlyInput">
                                <label>Overall Feedback</label>
                                <TextBox style={{ width: '100%', height: 'auto' }}
                                    name="overallFeedback"
                                    value={feedback.overallFeedback}
                                    readOnly={true}
                                   
                                    className={errors.feedback ? 'error' : ''} />
                                {errors.feedback && <div className="error-text">{errors.feedback}</div>}
                            </div>


                        </div>

                        }
                        <div className="buttons">
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


